import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CreditNote } from '@app/modules/settings/models/credit_note';
import { Invoice } from '@app/modules/settings/models/invoice';
import { BillingService } from '@app/shared/services/billing/billing.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-invoices-table',
  templateUrl: './invoices-table.component.html',
  styleUrls: ['./invoices-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoicesTableComponent implements OnInit {
  @Input() loading: boolean;
  @Input() invoices: Invoice[];

  public downloading$ = new BehaviorSubject<Record<string, boolean>>({});

  constructor(private readonly billingService: BillingService) { }

  ngOnInit(): void { }

  public downloadFile(file: Invoice | CreditNote) {
    if (!file.download) {
      return;
    }

    this.downloading$.next({ ...this.downloading$.value, [file.id]: true });

    this.billingService.getDownloadableFile(file.download).subscribe((res) => {
      this.downloading$.next({ ...this.downloading$.value, [file.id]: false });
      if (res.url) {
        window.open(res.url);
      }
    });
  }
}
